var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "32px",
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pdf-icon-large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,32 L22.5,32 C23.8807119,32 25,30.8743159 25,29.4857143 L25,13.6551697 C25,10.0396514 23.5702924,6.57081968 21.0227273,4.00530134 C18.4770873,1.44172171 15.0136736,-2.44001488e-15 11.4008875,0 L2.5,0 L2.5,0 C1.11928813,0 0,1.12568406 0,2.51428571 L0,29.4857143 C0,30.8743159 1.11928813,32 2.5,32 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Config",
    transform: "translate(-208.000000, -1051.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf-icon-large",
    transform: "translate(208.000000, 1051.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sheet",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "bg",
    fill: "#F98786",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "shadow",
    fill: "#FF5D5D",
    mask: "url(#mask-2)",
    points: "0.0799242424 9.65792226 15.4545455 9.65792226 15.4545455 24.4534199 0.0331864474 26.7421389"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(0.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25,0 L18.75,0 C19.4403559,0 20,0.596953667 20,1.33333333 L20,14.6666667 C20,15.4030463 19.4403559,16 18.75,16 L1.25,16 C0.559644063,16 0,15.4030463 0,14.6666667 L0,1.33333333 C0,0.596953667 0.559644063,0 1.25,0 Z",
    id: "Rectangle-21",
    fill: "#E33147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8787433,3.42857143 C11.2761367,6.30746851 11.8940161,7.433967 14.4444444,8.04134254 L14.3929014,10.063119 C11.4751037,10.2339496 9.85601066,10.7626928 6.72108611,12.5714286 L5.55555556,10.9200281 C6.9461349,9.73549541 7.75396816,8.73670952 8.20194075,7.72347615 C8.61613626,6.78664044 8.73682055,5.9744618 8.83892707,3.95284737 C8.84956393,3.74100499 8.84956393,3.74100499 8.86061296,3.52245521 L10.8787433,3.42857143 Z M10.349171,7.11313621 C10.223762,7.51327825 10.1072163,7.82345216 9.9995339,8.04365796 C9.89185151,8.26386375 9.72591726,8.53864421 9.50173115,8.86799935 L11.4713782,8.36309197 C11.210693,8.16108876 10.9786082,7.94676298 10.7751238,7.72011462 C10.5716395,7.49346626 10.4296552,7.29114012 10.349171,7.11313621 Z",
    id: "Rectangle-18-Copy-6",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.7c32e3fc4ffd9008ced1ab515e3a29a4.svg";
export { ForwardRef as ReactComponent };